module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"chunkError":"Oops, our email editor didn’t load. Please refresh the page to write an email.","refresh":"Refresh"}}')
  delete Component.options._Ctor
}
